const formatNumber = (num) => {
    return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(num);
};

/**
 * Validates folder name for cross-platform compatibility (S3, Windows, macOS, iOS, Android)
 * @param {string} folderName - The folder name to validate
 * @returns {object} - { isValid: boolean, error: string }
 */
export const validateFolderName = (folderName) => {
  if (!folderName || typeof folderName !== 'string') {
    return { isValid: false, error: 'Folder name is required' };
  }

  const trimmedName = folderName.trim();
  
  if (trimmedName.length === 0) {
    return { isValid: false, error: 'Folder name cannot be empty' };
  }

  if (trimmedName.length > 255) {
    return { isValid: false, error: 'Folder name is too long (max 255 characters)' };
  }

  // Check for invalid characters across platforms
  const invalidChars = /[<>:"/\\|?*\u0000-\u001f]/;
  if (invalidChars.test(trimmedName)) {
    return { isValid: false, error: 'Folder name contains invalid characters (< > : " / \\ | ? * or control characters)' };
  }

  // Check for reserved names (Windows)
  const reservedNames = /^(CON|PRN|AUX|NUL|COM[1-9]|LPT[1-9])(\.|$)/i;
  if (reservedNames.test(trimmedName)) {
    return { isValid: false, error: 'Folder name is a reserved system name' };
  }

  // Check for names that start or end with spaces or dots
  if (trimmedName.startsWith('.') || trimmedName.endsWith('.') || 
      trimmedName.startsWith(' ') || trimmedName.endsWith(' ')) {
    return { isValid: false, error: 'Folder name cannot start or end with spaces or dots' };
  }

  // Check for consecutive dots (path traversal attempt)
  if (trimmedName.includes('..')) {
    return { isValid: false, error: 'Folder name cannot contain consecutive dots' };
  }

  return { isValid: true, error: null };
};

export { formatNumber };